import React, { createContext, useContext, useMemo } from 'react';
import { useDTGateways } from '../hooks/useDTGateways';

const DTGatewaysContext = createContext({ gateways: [], loading: true, refresh: () => {} });

/**
 * Single source of gateway list + live connection state for the DT dashboard.
 * Mounted once in DTDashboardConfigurator so widgets can read shared state via
 * useDTGatewaysContext() without each instance triggering its own fetch.
 */
export function DTGatewaysProvider({ children }) {
  const { gateways, loading, refresh } = useDTGateways();
  const value = useMemo(() => ({ gateways, loading, refresh }), [gateways, loading, refresh]);
  return <DTGatewaysContext.Provider value={value}>{children}</DTGatewaysContext.Provider>;
}

export function useDTGatewaysContext() {
  return useContext(DTGatewaysContext);
}
